import { Component, OnInit, Directive, Renderer2, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FormFieldRegistrationRelations } from "../../../models/formfield_registration_relations";
import { FormFieldRegistrationsControllerService } from "../../../services/crossed-tables/formfield-registrations-controller.service";
import { BaseError } from "../base-error";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";

@Component({
  selector: "app-formfields-registrations",
  templateUrl: "./formfield-registrations.component.html",
  providers: [FormFieldRegistrationsControllerService, FormControllerService],
})
export class FormFieldRegistrationsComponent extends BaseError implements OnInit {
  public formFieldRegistrationRelations: FormFieldRegistrationRelations[][] = [];
  public serviceId: string;
  public selectedFormFieldRegistrationRelations: FormFieldRegistrationRelations;
  public tableSwitched: boolean = false;
  public formFieldsGroup: any[] = [];

  constructor(private formFieldRegistrationsControllerService: FormFieldRegistrationsControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService,
              private renderer: Renderer2,
              private formControllerService: FormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getFormFieldRegistrationRelations();
  }

  public getFormFieldRegistrationRelations() {
    this.formFieldRegistrationsControllerService.getFormFieldRegistrationsRelationsList(this.serviceId).subscribe(
      (data) => {

        this.formFieldRegistrationRelations = data;
        if (this.formFieldRegistrationRelations[0].length > 0) {
          this.formFieldRegistrationRelations.sort((a, b) => {
            const aString = a[0].formLabel + a[0].formFieldLabel;
            const bString = b[0].formLabel + b[0].formFieldLabel;
            if (aString < bString) { return -1; }
            if (aString > bString) { return 1; }
            return 0;
          });
        }
        if (this.tableSwitched) {
          this.tableSwitched = false;
          this.switchHeadings();
        }
        this.formControllerService.getFilteredFormFields(this.serviceId, null, true, true, false, false, true, true, true).subscribe((fdata) => {
          this.formFieldsGroup = this.transformRowsAndColumnsToComponents(fdata);
        });
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  private transformRowsAndColumnsToComponents(components: any[]): any[] {
    return components.map(component => {
      if (component.rows && component.type === "table") {
        component.components = this.transformRowsAndColumnsToComponents(this.getComponentsForRows(component.rows));
        delete component.rows;
      }

      if (component.columns && component.type === "columns") {
        component.components = this.transformRowsAndColumnsToComponents(this.getComponentsForColumns(component.columns));
        delete component.columns;
      }

      if (component.components && component.type === "select") {
        delete component.components;
      }

      if (component.components) {
        component.components = this.transformRowsAndColumnsToComponents(component.components);
      }
      return component;
    });
  }

  private getComponentsForRows(rows: any[]) {
    const components = [];
    if (Array.isArray(rows)) {
      rows.forEach(row => {
        if (Array.isArray(row)) {
          row.forEach((r: any) => {
            if (r.components && Array.isArray(r.components)) {
              r.components.forEach((component: any) => {
                components.push(component);
              });
            }
          });
        }
      });
    }
    return components;
  }

  private getComponentsForColumns(columns: any[]) {
    const components = [];
    if (Array.isArray(columns)) {
      columns.forEach(column => {
        components.push(column);
      });
    }
    return components;
  }

  public toggleClass(event: any, cssclass: string) {
    const elem = event.target;
    const parent = elem.closest(".group-toggle");
    parent.classList.toggle(cssclass);
  }

  public updateFormFieldRegistration(formFieldRegistrationRelations: FormFieldRegistrationRelations) {
    this.formFieldRegistrationsControllerService.updateFormFieldRegistrations(this.serviceId, formFieldRegistrationRelations).subscribe(
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editFormFieldRegistrationEvent(formFieldRegistrationRelations: FormFieldRegistrationRelations) {
    if (FormFieldRegistrationRelations) {
      this.selectedFormFieldRegistrationRelations = formFieldRegistrationRelations;
      if (formFieldRegistrationRelations.formFieldHasRegistration) {
        this.selectedFormFieldRegistrationRelations.formFieldHasRegistration = false;
        this.updateFormFieldRegistration(this.selectedFormFieldRegistrationRelations);
      } else {
        formFieldRegistrationRelations.formFieldHasRegistration = true;
        this.updateFormFieldRegistration(formFieldRegistrationRelations);
      }
    }
  }

  public editFieldRegistrationEvent(event, status) {
    this.formFieldRegistrationRelations.forEach((row) => {
      row.forEach((relation) => {
        if (event.group.key === relation.fieldKey
          && event.registration.registrationId === relation.registrationId) {
          if (status === null) {
            relation.formFieldHasRegistration = !relation.formFieldHasRegistration;
          } else {
            relation.formFieldHasRegistration = status;
          }
          this.updateFormFieldRegistration(relation);
        }
      });
    });
  }

  public toggleGroup(event): void {
    event.items.forEach((i) => {
      this.editFieldRegistrationEvent(
        {
          registration: event.registration,
          group: i,
        },
        event.status,
      );
    });
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.formFieldRegistrationRelations[0]) {
      for (let j = 0; j < this.formFieldRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.formFieldRegistrationRelations.length; i++) {
          newRow.push(this.formFieldRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.formFieldRegistrationRelations = switchedEntries;
  }

  public getFieldGroups(fields: any[]): any[] {
    const groups = [];
    fields.forEach((f) => {
      const groupIndex = this.groupPosition(groups, f.formLabel);
      if (groupIndex === -1) {
        groups.push({
          titleName: f.formLabel,
          items: [{
            fieldName: f.formFieldLabel,
            item: f,
          }],
        });
      } else {
        groups[groupIndex].items.push({
          fieldName: f.formFieldLabel,
          item: f,
        });
      }
    });
    return groups;
  }
  public groupPosition(groups: any[], name: string): number {
    let index = -1;
    groups.forEach((g, i) => {
      if (g.titleName === name) {
        index = i;
      }
    });
    return index;
  }

}
